var _path, _ellipse, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 43",
    width: "47px",
    height: "47px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4b6582",
    d: "M29,0C12.984,0,0,6.716,0,15v13c0,8.284,12.984,15,29,15c16.016,0,29-6.716,29-15V15 C58,6.716,45.016,0,29,0z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 15,
    fill: "#4b6582",
    rx: 29,
    ry: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#67849e",
    d: "M15,8c-0.42,0-0.811-0.267-0.95-0.687c-0.173-0.524,0.112-1.09,0.636-1.263 c1.294-0.427,2.66-0.717,4.105-1.024c0.542-0.116,1.071,0.229,1.186,0.77s-0.23,1.071-0.77,1.186 c-1.391,0.295-2.705,0.575-3.895,0.968C15.209,7.984,15.104,8,15,8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#67849e",
    d: "M10.999,22c-0.158,0-0.317-0.037-0.466-0.116c-3.967-2.098-6.154-4.721-6.158-7.388 C4.371,12.086,6.105,9.94,9.53,8.117c0.487-0.259,1.094-0.074,1.353,0.413c0.259,0.487,0.075,1.093-0.413,1.353 c-1.87,0.995-4.098,2.603-4.095,4.61c0.002,1.836,1.906,3.938,5.093,5.623c0.488,0.258,0.675,0.863,0.417,1.352 C11.705,21.807,11.358,22,10.999,22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#67849e",
    d: "M29,26C29,26,29,26,29,26c-4.138-0.001-8.731-0.707-13.281-2.041 c-0.53-0.155-0.833-0.71-0.678-1.241s0.713-0.833,1.241-0.678C20.652,23.321,25.05,23.999,29,24c0.552,0,1,0.448,1,1 C30,25.552,29.552,26,29,26z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#28384c",
    d: "M29,30C12.984,30,0,23.284,0,15v13c0,8.284,12.984,15,29,15c16.016,0,29-6.716,29-15V15 C58,23.284,45.016,30,29,30z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.1be5b26441d91f59d822874ecd123dd9.svg";
export { ForwardRef as ReactComponent };